// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paymentPortalLink } from "@guestsupply/App/Widgets/PaymentPortal/PaymentPortalLink";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { createLinkIconStyles, hideElementOnPrint, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

paymentPortalLink.paymentLinkWrapper = {
    css: css`
        text-align: right;
        padding: 25px 0;
        ${xScreen("lte", "sm")} {
            text-align: left;
            padding: 15px 0 0 0;
        }
    `,
};

paymentPortalLink.paymentPortalLink = {
    ...createLinkIconStyles(CaretRight, {
        icon: {
            iconProps: {
                size: 12,
            },
        },
        css: css`
            margin-left: auto;
            margin-top: 5px;
            ${hideElementOnPrint}
        `,
    }),
};

paymentPortalLink.navigationListLink = {
    color: "text",
    typographyProps: {
        size: 13,
    },
};
